import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { CurrentMember, MemberListItem } from './types/member';

const request = createAppRequest();

export async function getCurrentMember(options?: ApiRequestOptions) {
  return request<CurrentMember>('/bff/iam-ui/members/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getMembers(params?: {
  keyword?: string;
  pageNo?: number;
  pageSize?: number;
}) {
  return request<{ list: MemberListItem[]; total: number }>(
    '/bff/iam-ui/members',
    { method: 'GET', params },
  );
}
